/* eslint-disable @next/next/no-img-element */
import { Fragment } from 'react';

type ImageSize = {
  url?: string | null;
  width?: number | null;
  height?: number | null;
  mimeType?: string | null;
  filesize?: number | null;
  filename?: string | null;
};

export type Sizes = Record<string, ImageSize | undefined>;

type Breakpoints = Record<string, number>;
export interface UiModPictureBaseProps {
  sizes?: Sizes;
  breakpoints: Breakpoints;
  alt: string;
  className?: string;
  imageClassName?: string;
}

export function UiModPictureBase({
  sizes,
  breakpoints,
  alt,
  className,
  imageClassName
}: UiModPictureBaseProps) {
  if (!sizes) return null;

  const sources = Object.entries(breakpoints)
    .sort(([, a], [, b]) => a - b)
    .map(([key, breakpoint], index) => {
      const normal = sizes[key];
      const retina = sizes[`${key}@2x`];

      if (!normal) return null;

      const srcSet = [
        normal?.url ? `${normal.url}?${key} 1x` : null,
        retina?.url ? `${retina.url}?${key}@2x 2x` : null
      ]
        .filter(Boolean)
        .join(', ');

      if (!srcSet) return null;

      const isLast = index === Object.keys(breakpoints).length - 1;

      return (
        <Fragment key={key}>
          <source
            media={isLast ? undefined : `(max-width: ${breakpoint}px)`}
            srcSet={srcSet}
            type={normal?.mimeType || retina?.mimeType || 'image/jpeg'}
          />
          {isLast && (
            <img
              className={imageClassName}
              src={normal.url || ''}
              width={normal.width || undefined}
              height={normal.height || undefined}
              alt={alt}
            />
          )}
        </Fragment>
      );
    });

  return <picture className={className}>{sources}</picture>;
}
